export const colorHeadings = '#1E1F21';
export const colorLink = '#0077FF';

export const fontSans = '"IBM Plex Sans",-apple-system,BlinkMacSystemFont,San Francisco,Segoe UI,sans-serif';
export const fontMono = '"IBM Plex Mono",-apple-system,BlinkMacSystemFont,San Francisco,Segoe UI,sans-serif';



// WEBPACK FOOTER //
// src/theme/config.js